import merge from '~lodash.mergewith'
import { init, Replay } from '~@sentry/vue'
import * as CoreSdk from '~@sentry/core'
import * as BrowserSdk from '~@sentry/browser-sdk'
import { ExtraErrorData, ReportingObserver, RewriteFrames } from '~@sentry/integrations'

export { init }
export const SentrySdk = { ...CoreSdk, ...BrowserSdk }

export function getConfig (ctx) {
  /* eslint-disable object-curly-spacing, quote-props, quotes, key-spacing, comma-spacing */
  const config = {
    dsn:"https:\u002F\u002Ffeed1c1f78bb4eaca7810e5de52410bc@o331533.ingest.sentry.io\u002F1854211",
    environment:"PRODUCTION_AZURE_1",
    release:"lole-headless@17.0.5",
    denyUrls:[new RegExp("lolenuxt1\\.azurewebsites\\.net", "i")],
    replaysSessionSampleRate:0.1,
    replaysOnErrorSampleRate:0.1,
  }

  config.integrations = [
    new ExtraErrorData(),
    new ReportingObserver({ types:["crash"] }),
    new RewriteFrames(),
    new Replay({ replaysSessionSampleRate:0.1,replaysOnErrorSampleRate:0.1 }),
  ]

  const runtimeConfigKey = "sentry"
  if (ctx.$config && runtimeConfigKey && ctx.$config[runtimeConfigKey]) {
    merge(config, ctx.$config[runtimeConfigKey].config, ctx.$config[runtimeConfigKey].clientConfig)
  }

  return config
}
